<template>
  <div class="main">
    <media-header-sci></media-header-sci>
    <div class="main-header">
      <el-row :gutter="10" style="
          display: flex;
          justify-content: flex-end;
          padding-top: calc(100vw * 80 / 1920);
        ">
        <el-col :lg="10" :sm="6" style="display: flex;">
          <img @click="toIndex()" src="https://bjlab.oss-cn-hangzhou.aliyuncs.com/image/research_logo.png"
               style="width: calc(100vw * 200 / 1920); height: calc(100vw * 85 / 1920)"/>
        </el-col>

        <el-col :lg="14" :sm="18" class="navbar">
          <div v-for="(item, index) in titles" :key="index" :class="item.selected ? 'title_selected' : ''" class="title"
               @click="toPage(item)">
            {{ item.title }}
          </div>
          <div class="title">
            <div style="
                display: flex;
                justify-content: center;
                align-items: center;
                width: calc(100vw * 50 /1920);
                height: calc(100vw * 50 /1920);
                border-radius: 50%;
                background-color: #4063f9;
                margin-top: calc(100vw * -10 /1920);
              ">
              <img src="../assets/icon/search.png" style="width: calc(100vw * 35 /1920); height: calc(100vw * 35 /1920)"/>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="el-main">
      <el-row :gutter="10" style="margin-top: calc(100vw * -20 / 1920)">
        <el-col :span="24" style="display: flex; justify-content: center; align-items: center">
          <div class="part-main">
            <el-row class="context-row" :gutter="50" style="margin-top: 300px; padding: 0 calc(100vw * 50 / 1920)">
              <el-col class="media-768-vedio1" :lg="13" :sm="24" style="
                  padding-bottom: calc(100vw * 20 / 1920);
                  display: flex;
                  flex-direction: column;
                ">
                <img class="sceience-video-1" src="https://bsd-files.oss-cn-hangzhou.aliyuncs.com/BaoJin/science/AI.png"
                     style="width: 100%;"/>
                <div class="main-title" style="
                    margin-top: calc(100vw * 30 / 1920);
                    color: #b7fffc;
                    font-size: calc(100vw * 20 / 1920);
                    text-align: left;
                    font-weight: bold;
                  ">
                  AI-BI Cooperation
                </div>
              </el-col>
              <el-col class="science-line" :lg="9" :sm="24" style="
                  padding-bottom: calc(100vw * 20 / 1920);
                  display: flex;
                  flex-direction: column;
                ">
                <div class="media-1200-talk" style="width: 100%; height: auto">
                  <img src="https://bjlab.oss-cn-hangzhou.aliyuncs.com/image/science_line.png"/>
                </div>
                <div class="main-text" style="
                    font-size: calc(100vw * 18 / 1920);
                    color: #ffffff;
                    text-align: left;
                    line-height: calc(100vw * 45 / 1920);
                    margin-top: calc(100vw * 10 / 1920);
                    padding: 0 calc(100vw * 5 / 1920);
                  ">
                  ‘Artificial and Biological Intelligence Cooperation Association’
                  ‘AI-BI cooperation’ was founded in 2023 by a group of scientists who work in brain science (Jin BAO
                  and Pengchen ZHOU) and computer science (Quanying LIU and Yatao BIAN). This association was founded to
                  gather researchers from multiple disciplines, and from both the academy and industry. We meet
                  regularly for discussion about how to apply AI tools in understanding brain, as well as how to improve
                  AI with principles learnt from neuroscience.
                </div>
              </el-col>
            </el-row>

            <el-row class="context-row" :gutter="50" style="margin-top: calc(100vw * 100 / 1920); padding: 0 calc(100vw * 50 / 1920)">
              <el-col class="media-768-vedio1" :lg="13" :sm="24" style="
                  padding-bottom: calc(100vw * 20 / 1920);
                  display: flex;
                  flex-direction: column;
                ">
                <img class="sceience-video-1" src="https://bjlab.oss-cn-hangzhou.aliyuncs.com/image/science_1.png"
                     style="width: 100%;"/>
                <div class="main-title" style="
                    margin-top: calc(100vw * 30 / 1920);
                    color: #b7fffc;
                    font-size: calc(100vw * 20 / 1920);
                    text-align: left;
                    font-weight: bold;
                  ">
                  Perception sees the world, Jin BAO @TEDx Hangzhou 2019
                </div>
                <div class="media-768-http">
                  <i><a style="color: #fff;text-decoration: none;"
                        href="https://v.youku.com/v_show/id_XNDU0NDQ4MjkwOA==.html">https://v.youku.com/v_show/id_XNDU0NDQ4MjkwOA==.html</a></i>
                </div>
              </el-col>
              <el-col class="science-line" :lg="9" :sm="24" style="
                  padding-bottom: calc(100vw * 20 / 1920);
                  display: flex;
                  flex-direction: column;
                ">
                <div class="media-1200-talk" style="width: 100%; height: auto">
                  <img src="https://bjlab.oss-cn-hangzhou.aliyuncs.com/image/science_line.png"/>
                </div>
                <div class="main-text" style="
                    font-size: calc(100vw * 18 / 1920);
                    color: #ffffff;
                    text-align: left;
                    line-height: calc(100vw * 45 / 1920);
                    margin-top: calc(100vw * 10 / 1920);
                    padding: 0 calc(100vw * 5 / 1920);
                  ">
                  This talk is about how we see color and how we perceive the
                  world. Dr. Bao introduced photoreceptors sensing and encoding
                  light spectrum in the retina. She described the recent
                  nanotechnique for seeing infrared images. And she stimulated
                  the audience to think how we perceive the world is shaped by
                  our sensory system.
                </div>
              </el-col>
            </el-row>

            <el-row class="context-row" :gutter="50" style="margin-top: 100px; padding: 0 50px;margin-bottom: 500px;">
              <el-col class="media-768-video2" :lg="13" :sm="24" style="
                  padding-bottom: calc(100vw * 20 / 1920);
                  display: flex;
                  flex-direction: column;
                ">
                <img src="https://bjlab.oss-cn-hangzhou.aliyuncs.com/image/science_2.png"/>
                <div class="media-768-cell main-title" style="
                    margin-top: calc(100vw * 30 / 1920);
                    color: #b7fffc;
                    font-size: calc(100vw * 20 / 1920);
                    text-align: left;
                    font-weight: bold;
                  ">
                  Video abstract for Cell, 2019
                </div>
                <div class="media-768-http">
                  <i><a style="color: #fff;text-decoration: none;"
                        href="https://www.youtube.com/watch?v=v8aD3XZnGkM">https://www.youtube.com/watch?v=v8aD3XZnGkM</a></i>
                </div>
              </el-col>
              <el-col class="media-768-con" :lg="9" :sm="24" style="
                  padding-bottom: calc(100vw * 20 / 1920);
                  display: flex;
                  flex-direction: column;
                ">
                <div class="media-1200-talk2" style="width: 100%; height: auto">
                  <img src="https://bjlab.oss-cn-hangzhou.aliyuncs.com/image/science_line.png"/>
                </div>
                <div class="media-768-Beautyofscience main-text" style="
                    font-size: calc(100vw * 18 / 1920);
                    color: #ffffff;
                    text-align: left;
                    line-height: calc(100vw * 45 / 1920);
                    margin-top: calc(100vw * 10 / 1920);
                    padding: 0 calc(100vw * 5 / 1920);
                  ">
                  In collaboration with #Beautyofscience 美丽科学
                  (beautyofscience.cn), we made this video abstract for Cell to
                  explain how we achieved near infrared image vision in mice.
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>

      <el-row class="main-footer" :gutter="10" style="margin-top: calc(100vw * 60 / 1920)">
        <img
          :src="require('@/assets/image/footer_science.png')"
          style="width: 100%; display: block;"
        />
      </el-row>
    </div>
  </div>
</template>

<script>
  import mediaHeaderSci from "./media/mediaHeaderSci";

  export default {
    name: "Index",
    components: {
      mediaHeaderSci,
    },
    data() {
      return {
        titles: [
          //'Research','People','Science And Art','Join Us','Contact Us'
          {
            title: "Research",
            key: "Research",
          },
          {
            title: "People",
            key: "People",
          },
          {
            title: "Science And Art",
            key: "Science",
            selected: true,
          },
          {
            title: "Join us",
            key: "Joinus",
          },
          {
            title: "Contact us",
            key: "Contactus",
          },
        ],
        current: 2,
      };
    },
    mounted() {
    },
    methods: {
      toPage(item) {
        this.$router.push(item.key);
      },
      toIndex() {
        this.$router.push({path: "/"});
      },
      initVideo() {
        //初始化视频方法
        let myPlayer = this.$video(myVideo, {
          //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
          controls: true,

          //自动播放属性,muted:静音播放,并且从视频加载完成后就开始播放
          autoplay: false,

          //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
          preload: "auto",

          //设置视频播放器的显示宽度（以像素为单位,也可以使用%）
          width: "100%",

          //设置视频播放器的显示高度（以像素为单位,也可以使用%）
          height: "100%",

          //设置视频的封面
          poster: "https://bjlab.oss-cn-hangzhou.aliyuncs.com/image/science_1.png",
        });
      },
    },
  };
</script>

<style scoped>
  img {
    object-fit: contain;
  }

  .main {
    overflow-x: hidden;
    overflow-y: hidden;
    text-rendering: optimizelegibility;
  }

  .navbar {
    font-family: bahnschrift;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: nowrap;
    cursor: pointer;
    letter-spacing: calc(100vw * -1 /1920);
  }

  .title {
    font-family: 'mon';
    font-size: calc(100vw * 20 / 1920);
    color: #4063f9;
    padding-top: calc(100vw * 10 / 1920);
    text-rendering: optimizelegibility;
  }

  .title_selected {
    font-weight: bold;
    position: relative;
    letter-spacing: calc(100vw * -1 / 1920);
  }

  .title_selected::after {
    content: "__";
    letter-spacing: calc(100vw * -1 /1920);
    color: #ff6a4a;
    font-weight: bold;
    position: absolute;
    left: calc(100vw * 10 / 1920);
    bottom: calc(100vw * 30 / 1920);
    font-size: calc(100vw * 25 / 1920);
  }

  .item {
    background-color: #ffffff;
    width: 15%;
    height: 65%;
    border: calc(100vw * 1 / 1920) solid #b4b4b4;
    margin: 0 0px;
  }

  .selected {
    width: 20%;
    height: 75%;
    box-shadow: calc(100vw * 1 / 1920) calc(100vw * 1 / 1920) #b4b4b4;
  }

  .item-title {
    display: flex;
    justify-content: flex-start;
    font-size: calc(100vw * 45 / 1920);
    color: #4063f9;
  }

  .bold {
    font-weight: bold;
  }

  .part-main {
    z-index: 1;
    width: 100%;
    background: url("https://bjlab.oss-cn-hangzhou.aliyuncs.com/image/science_bg_1.png") no-repeat;
    background-size: 100% 100%;
    position: relative;
  }

  .el-header,
  .el-footer {
    text-align: center;
    line-height: calc(100vw * 30 / 1920);
  }

  .el-main {
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }

  .image-fit {
    width: 100%;
    height: 100%;
    object-fit: scale-down;
  }

  .context-row {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }

  @media screen and (max-width: 1200px) {

    /*当屏幕尺寸小于1200px时，应用下面的CSS样式*/
    .main {
      width: 100%;
    }

    .part-main {
      min-height: 2400px;
    }
  }

  /*当屏幕尺寸大于1200px时，应用下面的CSS样式*/
  @media screen and (min-width: 1200px) {
    .main {
      width: 80%;
      margin-left: 10%;
    }

    .part-main {
      min-height: calc(100vw * 1800 / 1920);
    }
  }

  @media screen and (min-width: 769px) and (max-width: 1400px) {
    .title {
      font-size: 14px !important;
    }

    .main-header {
      padding: 0 20px;
    }

    .title_selected::after {
      bottom: 10px;
    }

    .main-title {
      font-size: 14px !important;
      padding: 0 40px;
    }

    .main-text {
      font-size: 14px !important;
      padding: 0 40px !important;
    }

    .media-1200-talk {
      padding: 0 40px !important;
    }

    .media-768-http {
      font-size: 13px !important;
      padding: 0 40px !important;
    }
  }

  /*当屏幕尺寸大于768px时，组件隐藏*/
  .media-768-header {
    display: none;
  }

  .header-hidden {
    display: none;
  }

  .media-768-header {
    display: none;
  }

  .media-768-footer {
    display: none;
  }

  @media screen and (min-width: 768px) and (max-width: 1200px) {

    .media-768-vedio1 {
      height: auto;
    }

    .media-768-vedio1 img {
      width: 90% !important;
      height: auto !important;
      margin: 0 auto;
    }

    .part-main {
      min-height: 2600px;
    }

    .context-row:nth-child(3) {
      margin-bottom: 800px !important;
    }
  }



  @media screen and (max-width: 768px) {

    img {
      width: 100% !important;
      height: auto !important;   /* 关键：禁止拉高 */
      object-fit: contain;
      display: block;
    }

  .el-main {
        padding-top: 50px !important;
    }
  
    .media-768-header {
      display: block;
    }

    /* 当屏幕尺寸大于768px时，组件隐藏 */
    .main-header {
      display: none;
    }

    .main-footer {
      display: none;
    }

    .part-main {
      background-size: cover;       /* 允许裁切 */
      background-position: center;
    }

    .part-main > .el-row {
      margin-top: 0 !important;
      padding: 0 34px !important;
    }

    .el-main {
      padding: 0;
    }

    .media-768-vedio1 {
      width: 100%;
      height: auto !important;
      margin-top: 10%;
      padding-bottom: 12px !important;
    }

    .media-768-vedio1 > div {
      margin-top: 12px !important;
      font-size: 12px !important;
      padding-bottom: 0 !important;
    }

    .media-768-video2 {
      margin-top: 80px;
    }

    .media-768-http {
      color: #ffffff;
      font-size: 12px;
      opacity: 0.6;
      white-space: pre-wrap;
      text-align: left;
    }

    .media-768-http i {
      display: inline-block;
    }

    .science-line {
      height: auto !important;
    }

    .science-line > div {
      font-size: 12px !important;
      line-height: 20px !important;
    }

    .science-line > div:nth-child(2) {
      padding: 0 !important;
    }

    .media-768-video2 {
      height: auto !important;
      padding-bottom: 12px !important;
    }

    /* 美丽科学 */
    .media-768-cell {
      font-size: 12px !important;
      margin-top: 12px !important;
    }

    .media-768-http {
      margin-top: 12px;
    }

    .media-768-Beautyofscience {
      padding: 12px 0 0 0 !important;
      font-size: 12px  !important;
      line-height: 12px  !important;
    }

    .media-768-con {
      height: auto !important;
    }

    .context-row:nth-child(3) {
      margin-bottom: 250px !important;
    }
  }

  @media screen and (min-width: 2000px) and (max-width: 3000px) {
    .search_icon {
      width: calc(100vw * 32 / 1920) !important;
      height: calc(100vw * 32 / 1920) !important;
    }


    .part-main {
      min-height: calc(100vw * 2400 / 1920);
    }
  }

  @media screen and (min-width: 3000px) {

    .media-1200-talk {
      height: calc(100vw * 30 / 1920) !important;
    }

    .media-1200-talk img {
      width: 100%;
      height: calc(100vw * 20 / 1920) !important;
      object-fit: contain;
    }

    .media-1200-talk2 {
      height: calc(100vw * 30 / 1920) !important;
    }

    .media-1200-talk2 img {
      width: 100%;
      height: calc(100vw * 20 / 1920) !important;
      object-fit: contain;
    }


    .main {
      width: 70%;
      margin: 0 auto;
    }

    .part-main {
      min-height: calc(100vw * 2000 / 1920) !important;
    }

    .context-row {
      margin-top: calc(100vw * 250 / 1920) !important;
    }

    .context-row:nth-child(3) {
      margin-bottom: calc(100vw * 500 / 1920) !important;
    }

    .science2_row {
      margin-top: calc(100vw * 200 / 1920) !important;
    }

    .search_icon {
      width: calc(100vw * 28 / 1920) !important;
      height: calc(100vw * 28 / 1920) !important;
    }

    .title {
      font-size: calc(100vw * 20 / 1920) !important;
    }

    .title > div {
      width: calc(100vw * 50 / 1920) !important;
      height: calc(100vw * 50 / 1920) !important;
    }

    .title img {
      width: 70% !important;
      height: 70% !important;
    }

    .media-768-http {
      font-size: calc(100vw * 13 / 1920) !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Science.vue